import { render, staticRenderFns } from "./ModalPrivate.vue?vue&type=template&id=26777f55&"
import script from "./ModalPrivate.vue?vue&type=script&lang=js&"
export * from "./ModalPrivate.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrivate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports